document.addEventListener('click', e => {
  const scrollTrigger = e.target.closest('[data-scroll]');
  if (scrollTrigger) {
    const el = document.querySelector(scrollTrigger.dataset.scroll);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  const submitTrigger = e.target.closest('[data-submit-product-form]');
  if (submitTrigger) {
    const form = document.querySelector(submitTrigger.dataset.submitProductForm);
    if (form) {
      const button = form.querySelector('button[type="submit"]');
      if (button) button.click();
    }
  }
});

function bindProductSection(root = document) {
  root.querySelectorAll('[data-variant-select]').forEach(select => {
    if (select.dataset.bound === 'true') return;
    select.dataset.bound = 'true';
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      const section = select.closest('.product-section');
      if (!section) return;
      const price = section.querySelector('[data-product-price]');
      const compare = section.querySelector('[data-compare-price]');
      if (price && option.dataset.price) price.textContent = option.dataset.price;
      if (compare) compare.textContent = option.dataset.compare || '';
      const stickyPrice = document.querySelector('[data-sticky-price]');
      if (stickyPrice && option.dataset.price) stickyPrice.textContent = option.dataset.price;
    });
  });
}

document.addEventListener('DOMContentLoaded', () => bindProductSection(document));
document.addEventListener('shopify:section:load', event => bindProductSection(event.target));
